import { Injectable } from '@angular/core';
import { BRANDING } from '../branding';

/** Backend used when the app runs on localhost (ng serve). */
export const LOCAL_API_URL = 'http://localhost:3000';

export type AppEnvironment = 'Local' | 'Production';

/**
 * Environment detection, mirroring vwappservices: on localhost the API lives on LOCAL_API_URL,
 * everywhere else the Angular build is served by the backend itself (same origin).
 */
@Injectable({ providedIn: 'root' })
export class ConfigurationService {
  readonly environment: AppEnvironment = window.location.origin.includes('localhost') ? 'Local' : 'Production';

  readonly appName = BRANDING.appName;
  readonly appVersion = '1.0.0';

  getBaseUrl(): string {
    return this.environment === 'Local' ? LOCAL_API_URL : window.location.origin;
  }

  /**
   * URL for a file stored by the backend upload handler. The backend serves UPLOAD_DIRECTORY at the
   * site root, so "uploads/profile-images/x.png" is reachable at "<base>/profile-images/x.png".
   */
  fileUrl(relativePath?: string | null): string {
    if (!relativePath) return '';
    const path = relativePath.replace(/\\/g, '/').replace(/^\/+/, '').replace(/^uploads\//, '');
    return `${this.getBaseUrl()}/${path}`;
  }
}
